module.exports = __webpack_public_path__ + "static/media/backIcon.274327c2.svg";